export default __webpack_public_path__ + "static/media/I0007.879ec5e3.png";